import { useInjection } from "@linkfluence/core/di";
import { useMutation } from "@tanstack/react-query";
import { InsightPage } from "@radarly/models/insight-pages/model";
import {
  InsightPageRepo,
  InsightPageRepositoryUID,
} from "../repositories/InsightPageRepo";

export function useGetInsightPage(projectId: number, id: InsightPage["id"]) {
  const repository = useInjection<InsightPageRepo>(InsightPageRepositoryUID);
  const { data, mutateAsync, isLoading, isError } = useMutation(async () => {
    return await repository.getInsightPage(projectId, id);
  });
  return {
    isLoading,
    page: data,
    getInsightPage: mutateAsync,
    error: isError,
  };
}
